import React from 'react';
import {useSelector} from 'react-redux';
import TipTapToolbar from './toolbar/TipTapToolbar';
import {editorSelector} from '../../../store/selectors/tiptapEditor.selectors';
import {AppState} from '../../../store/reducer';

function TipTap({id}: {id: string}): JSX.Element | null {
    const editor = useSelector((state: AppState) => editorSelector(state, id));
    if (!editor) return null;

    return <TipTapToolbar editor={editor} />;
}

export default TipTap;
